import { render } from "./GuidesView.vue?vue&type=template&id=506e66b2"
import script from "./GuidesView.vue?vue&type=script&lang=js"
export * from "./GuidesView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__